module.exports = __webpack_public_path__ + "img/logout-icon-color.b7cc4f8f.svg";